"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
var Product;
(function (Product) {
    /**
     * Client supports auto insurance quotes at end of auto loan form
     */
    Product["AGRICULTURAL"] = "AGRICULTURAL";
    Product["AUTO_INSURANCE_QUOTE"] = "AUTO_INSURANCE_QUOTE";
    Product["AUTO_LOAN"] = "AUTO_LOAN";
    Product["AUTO_PREQUAL"] = "AUTO_PREQUAL";
    Product["CLOSING_COSTS"] = "CLOSING_COSTS";
    Product["COMMERCIAL"] = "COMMERCIAL";
    Product["CONSTRUCTION"] = "CONSTRUCTION";
    Product["CREDIT_BOOSTER"] = "CREDIT_BOOSTER";
    Product["CREDIT_CARD"] = "CREDIT_CARD";
    Product["DIGITAL_MORTGAGE"] = "DIGITAL_MORTGAGE";
    Product["FINANCIAL_STATEMENT"] = "FINANCIAL_STATEMENT";
    Product["HOME_EQUITY"] = "HOME_EQUITY";
    Product["HOME_EQUITY_TURBO"] = "HOME_EQUITY_TURBO";
    Product["INSURANCE_QUOTE"] = "INSURANCE_QUOTE";
    Product["LAND"] = "LAND";
    Product["OTHER_VEHICLE"] = "OTHER_VEHICLE";
    Product["OVERDRAFT_PROTECTION"] = "OVERDRAFT_PROTECTION";
    Product["PERSONAL_LOAN"] = "PERSONAL_LOAN";
    Product["PURCHASE_TURBO"] = "PURCHASE_TURBO";
    Product["REFINANCE_TURBO"] = "REFINANCE_TURBO";
    Product["REVERSE_MORTGAGE"] = "REVERSE_MORTGAGE";
    Product["SERVICING"] = "SERVICING";
    Product["SMALL_BUSINESS"] = "SMALL_BUSINESS";
    Product["TITLE_QUOTE"] = "TITLE_QUOTE";
    /**
     * Verification of Income and Employment
     */
    Product["VOIE"] = "VOIE";
})(Product = exports.Product || (exports.Product = {}));
